<template>
    <BaseLayout>
        <div class="container mb-5">
            <div class="vstack gap-3 my-4">
                <div class="fs-15">Home /
                    <Link class="text-black" :href="route('front.listings.all')">Listings</Link> /
                    <Link class="text-black" :href="route('front.listings.all')" :method="get"
                        :data="{ make: $page.props.vehicle.maker.slug }">{{ $page.props.vehicle.make }}</Link> /
                    <Link class="text-black" :href="route('front.listings.all')" :method="get"
                        :data="{ make: $page.props.vehicle.maker.slug, model: $page.props.vehicle.car_model.slug }">{{
                            $page.props.vehicle.model }}</Link>
                </div>
                <h2 class="mb-0 ff-dsb">{{ $page.props.vehicle.title }}</h2>
                <div class="hstack gap-4 flex-wrap">
                    <div class="ff-dsb fs-15"><span class="text-primary">Make: </span>{{ $page.props.vehicle.make }}
                    </div>
                    <div class="ff-dsb fs-15"><span class="text-primary">Model: </span>{{ $page.props.vehicle.model }}
                    </div>
                    <div class="ff-dsb fs-15"><span class="text-primary">Location: </span>{{
                        $page.props.vehicle.location }}</div>
                </div>
            </div>
            <vue-easy-lightbox :visible="visibleRef" :imgs="imgsRef" :index="indexRef" :rotate-disabled="true"
                :move-disabled="true" @hide="onHide"></vue-easy-lightbox>
            <div class="rounded-4 overflow-hidden my-4" v-if="$page.props.vehicle.gallery_images.length > 1">
                <div class="row g-2">
                    <div class="col">
                        <div class="position-relative h-100">
                            <div class="position-absolute top-0 start-0 bg-trout-caviar px-3 py-2 rounded-bottom-3 rounded-start-0"
                                v-if="vehicle.discount > 0">
                                <div class="hstack gap-2 flex-wrap justify-content-between fs-sm-16 fs-14">
                                    <div class="text-white ff-dsb"><i class="fas fa-tags"></i> Special Offer!</div>
                                    <div class="text-white ff-dsb ms-sm-5 ms-3">{{ vehicle.discount_formatted }} OFF</div>
                                </div>
                            </div>
                            <img :src="$page.props.vehicle.thumbnail" :alt="$page.props.vehicle.title"
                                class="img-fluid object-fit-cover w-100 h-100" @click="show(0)">
                        </div>
                    </div>
                    <div class="col-sm-5 mb-n2 position-relative">
                        <button class="btn btn-light ff-dsm fs-14 rounded-3 px-4 position-absolute bottom-0 end-0 m-4"
                            @click="show">
                            <GridDotsIcon class="me-2" />
                            More photos
                        </button>
                        <div class="row g-2 h-100">
                            <div class="col-sm-6" v-for="(gallery, index) in $page.props.vehicle.gallery_images.slice(1, 5)">
                                <img :src="gallery ?? 'images/front/placeholder.png'" :alt="$page.props.vehicle.title" class="img-fluid object-fit-cover w-100 h-100" @click="show(index + 1)">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row g-4">
                <div class="col-md">
                    <div class="vstack gap-4">
                        <div class="shadow-sm rounded-4 border bg-white overflow-hidden">
                            <h4 class="text-primary mb-0 ff-dsb p-4">Vehicle Details</h4>
                            <div class="row g-0 list-group list-group-horizontal-md">
                                <div class="col-md-6 list-group-item rounded-0 p-3">
                                    <div class="hstack gap-2 fs-15 text-capitalize">
                                        <div>
                                            <CarIcon class="me-2" />
                                            Body
                                        </div>
                                        <div class="ms-auto ff-dsm">{{ $page.props.vehicle.body_type }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 list-group-item rounded-0 p-3">
                                    <div class="hstack gap-2 fs-15 text-capitalize">
                                        <div>
                                            <UserIcon class="me-2" />
                                            Seats
                                        </div>
                                        <div class="ms-auto ff-dsm">{{ $page.props.vehicle.seating_number }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 list-group-item rounded-0 p-3">
                                    <div class="hstack gap-2 fs-15 text-capitalize">
                                        <div>
                                            <MileageIcon class="me-2" />
                                            Mileage
                                        </div>
                                        <div class="ms-auto ff-dsm">{{ $page.props.vehicle.mileage_formatted }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 list-group-item rounded-0 p-3">
                                    <div class="hstack gap-2 fs-15 text-capitalize">
                                        <div>
                                            <EngineIcon class="me-2" />
                                            Engine Size
                                        </div>
                                        <div class="ms-auto ff-dsm">{{ $page.props.vehicle.engine_cc }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 list-group-item rounded-0 p-3">
                                    <div class="hstack gap-2 fs-15 text-capitalize">
                                        <div>
                                            <FuelIcon class="me-2" />
                                            Fuel Type
                                        </div>
                                        <div class="ms-auto ff-dsm">{{ $page.props.vehicle.fuel_type }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 list-group-item rounded-0 p-3">
                                    <div class="hstack gap-2 fs-15 text-capitalize">
                                        <div>
                                            <DoorIcon class="me-2" />
                                            Door
                                        </div>
                                        <div class="ms-auto ff-dsm">{{ $page.props.vehicle.num_of_doors }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 list-group-item rounded-0 p-3">
                                    <div class="hstack gap-2 fs-15 text-capitalize">
                                        <div>
                                            <CalendarIcon class="me-2" />
                                            Year
                                        </div>
                                        <div class="ms-auto ff-dsm">{{ $page.props.vehicle.year }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6 list-group-item rounded-0 p-3">
                                    <div class="hstack gap-2 fs-15 text-capitalize">
                                        <div>
                                            <TransmissionIcon class="me-2" />
                                            Transmission
                                        </div>
                                        <div class="ms-auto ff-dsm">{{ $page.props.vehicle.gear }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="shadow-sm rounded-4 border bg-white overflow-hidden"
                            v-if="$page.props.vehicle.description">
                            <h4 class="text-primary mb-0 ff-dsb p-4">Description</h4>
                            <div class="px-4" v-dompurify-html="$page.props.vehicle.description"></div>
                        </div>
                        <div class="shadow-sm rounded-4 border bg-white overflow-hidden"
                            v-if="$page.props.vehicle.vehicle_type !== 3">
                            <h4 class="text-primary mb-0 ff-dsb p-4 pb-0">Vehicle Financing</h4>
                            <div class="p-4">
                                <div class="vstack gap-4">
                                    <div class="text-center search-filters">
                                        <div class="bg-white rounded-top-4 d-inline-flex">
                                            <div class="btn-group flex-wrap bg-mercury p-2 rounded-4 gap-2">
                                                <input type="radio" class="btn-check" id="radio-loan"
                                                    name="vehicle_financing" autocomplete="off" checked>
                                                <label class="btn ff-dsb rounded-3 px-sm-5 px-3"
                                                    for="radio-loan">Loan</label>

                                                <input type="radio" class="btn-check" id="radio-insurance"
                                                    name="vehicle_financing" autocomplete="off">
                                                <label class="btn ff-dsb rounded-3 px-sm-5 px-3"
                                                    for="radio-insurance">Insurance</label>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="text-plaster opacity-100 my-0" />
                                    <div class="hstack gap-2">
                                        <div class="ff-dsb fs-13 text-gray">Vehicle Price:</div>
                                        <div class="ff-dsb fs-20 text-primary">{{
                                            $page.props.vehicle.discounted_price_formatted }}</div>
                                    </div>
                                    <div class="row g-4">
                                        <div class="col-sm-6" v-if="$page.props.vehicle.vehicle_type === 1">
                                            <div class="form-floating">
                                                <input type="text" class="form-control rounded-3"
                                                    v-model="loanFinancing.downpayment.value"
                                                    @input="recalculateLoan('downpayment')" id="input-down-payment"
                                                    placeholder="">
                                                <label for="input-down-payment" class="text-gray">Down Payment %</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6" v-if="$page.props.vehicle.vehicle_type === 1">
                                            <div class="form-floating">
                                                <input type="text" class="form-control rounded-3" id="input-amount"
                                                    v-model="loanFinancing.downpayment_amount.value"
                                                    @input="recalculateLoan('downpayment_amount')" placeholder="">
                                                <label for="input-amount" class="text-gray">Down Payment Amount</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-floating">
                                                <input type="text" class="form-control rounded-3" id="input-interest"
                                                    v-model="loanFinancing.interest_rate.value" placeholder=""
                                                    @input="recalculateLoan('interest_rate')">
                                                <label for="input-interest" class="text-gray">Bank Annual Interest Rate
                                                    %</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-floating">
                                                <select class="form-select rounded-3" placeholder=""
                                                    @input="recalculateLoan('tenure')"
                                                    v-model="loanFinancing.tenure.value">
                                                    <option value="9" v-if="$page.props.vehicle.vehicle_type === 1">9
                                                        Years (108 Months)</option>
                                                    <option value="8" v-if="$page.props.vehicle.vehicle_type === 1">8
                                                        Years (96 Months)</option>
                                                    <option value="7" v-if="$page.props.vehicle.vehicle_type === 1">7
                                                        Years (84 Months)</option>
                                                    <option value="6" v-if="$page.props.vehicle.vehicle_type === 1">6
                                                        Years (72 Months)</option>
                                                    <option value="5">5 Years (60 Months)</option>
                                                    <option value="4">4 Years (48 Months)</option>
                                                    <option value="3">3 Years (36 Months)</option>
                                                    <option value="2">2 Years (24 Months)</option>
                                                    <option value="1">1 Year (12 Months)</option>
                                                </select>
                                                <label for="input-interest" class="text-gray">Loan Tenure</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="text-center">
                                        <button class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4" type="submit"
                                            :disabled="updateLoanForm.processing"> Calculate <i
                                                v-if="updateLoanForm.processing"
                                                class="fad fa-spinner-third fa-spin"></i>
                                        </button>
                                    </div> -->
                                    <hr class="text-plaster opacity-100 my-0" />
                                    <div
                                        class="shadow-sm p-3 rounded-4 border border-chess-ivory bg-soft-pillow vstack gap-2 text-center col-sm-6 mx-auto">
                                        <div class="ff-dsb">Monthly Instalment Price</div>
                                        <div class="fs-30 ff-dsb text-primary lh-1">{{
                                            loanFinancing.monthly_price_formatted.value }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="vstack gap-4">
                        <div class="shadow-sm p-4 rounded-4 border border-chess-ivory bg-soft-pillow vstack gap-3"
                            v-if="$page.props.vehicle.vehicle_type === 1 || $page.props.vehicle.vehicle_type === 2">
                            <div class="ff-dsb">Vehicle Price</div>
                            <div class="fs-30 ff-dsb text-primary">{{ $page.props.vehicle.discounted_price_formatted }}
                                <span class="fs-14 text-black opacity-50 text-decoration-line-through"
                                    v-if="$page.props.vehicle.discount">{{
                                        $page.props.vehicle.price_formatted }}</span>
                            </div>
                            <div class="fs-20 ff-dsb">{{ $page.props.vehicle.monthly_price_formatted }} /mth</div>
                        </div>
                        <div class="vstack" v-else>
                            <span class="fs-32 ff-dsb text-primary mb-3">Car Rental</span>
                            <div
                                class="shadow-sm rounded-4 border border-chess-ivory bg-soft-pillow vstack rent-car-pricing-box">
                                <div class="ff-dsb fs-16">Rental Rates</div>
                                <!-- <div class="fs-16 ff-dsb text-primary">{{ $page.props.vehicle.daily_rate_formatted }} /daily</div> -->
                                <div class="d-flex justify-content-between border-1">
                                    <span class="ff-dsr fs-16">Daily</span>
                                    <span class="ff-dsb fs-16 text-primary">{{ $page.props.vehicle.daily_rate_formatted
                                    }}</span>
                                </div>
                                <div class="d-flex justify-content-between border-1">
                                    <span class="ff-dsr fs-16">Weekly</span>
                                    <span class="ff-dsb fs-16 text-primary">{{ $page.props.vehicle.weekly_rate_formatted
                                    }}</span>
                                </div>
                                <div class="d-flex justify-content-between border-1">
                                    <span class="ff-dsr fs-16">Monthly</span>
                                    <span class="ff-dsb fs-16 text-primary">{{
                                        $page.props.vehicle.monthly_rate_formatted }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4">
                            <SteeringIcon class="me-2" />Schedule Test Drive
                        </div> -->



                        <BookTestDriveForm :errors="$page.props.errors"
                            :booking_dates="$page.props.testDriveBookingDates"
                            :booking_slots="$page.props.testDriveBookingSlots"
                            v-if="$page.props.vehicle.vehicle_type === 1" />

                        <LeaseEnquiryForm :errors="$page.props.errors" v-if="$page.props.vehicle.vehicle_type === 2" />

                        <RentEnquiryForm :errors="$page.props.errors" v-if="$page.props.vehicle.vehicle_type === 3" />

                        <div class="shadow-sm rounded-4 border bg-white overflow-hidden"
                            v-if="$page.props.vehicle.staffs.length > 0">
                            <h4 class="text-primary mb-0 ff-dsb p-4 pb-0">Sales Agent Information</h4>
                            <div class="vstack gap-3 p-4" v-for="staff in $page.props.vehicle.staffs">
                                <div class="fs-15 ff-dsb">{{ staff.name }}</div>
                                <div class="fs-15 ff-dsm hstack gap-3">
                                    <div class="phone-icon d-flex">
                                        <PhoneIcon class="m-auto" />
                                    </div>
                                    {{ staff.contact }}
                                </div>
                                <div class="hstack gap-4">
                                    <a :href="'tel:' + staff.contact"
                                        class="btn btn-outline-custom rounded-4 px-4 py-3 fs-15 ff-dsm flex-fill">Call
                                        Dealer
                                        <ButtonArrowIcon class="ms-2" />
                                    </a>
                                    <a :href="'https://wa.me/' + staff.contact" target="_blank"
                                        class="btn btn-whatsapp rounded-4 py-3 px-3 text-white"><i
                                            class="fab fa-whatsapp fs-21"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BaseLayout>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import VueEasyLightbox, { useEasyLightbox } from 'vue-easy-lightbox';

import BookTestDriveForm from './BookTestDriveForm.vue';
import CalendarIcon from '../../../../../../resources/js/front/Components/icons/CalendarIcon.vue';
import CarIcon from '../../../../../../resources/js/front/Components/icons/CarIcon.vue';
import DoorIcon from '../../../../../../resources/js/front/Components/icons/DoorIcon.vue';
import EngineIcon from '../../../../../../resources/js/front/Components/icons/EngineIcon.vue';
import FuelIcon from '../../../../../../resources/js/front/Components/icons/FuelIcon.vue';
import MileageIcon from '../../../../../../resources/js/front/Components/icons/MileageIcon.vue';
import TransmissionIcon from '../../../../../../resources/js/front/Components/icons/TransmissionIcon.vue';
import UserIcon from '../../../../../../resources/js/front/Components/icons/UserIcon.vue';
import BaseLayout from '../../../../../../resources/js/front/Layouts/BaseLayout.vue';
import SteeringIcon from '../../../../../../resources/js/front/Components/icons/SteeringIcon.vue';
import ButtonArrowIcon from '../../../../../../resources/js/front/Components/icons/ButtonArrowIcon.vue';
import PhoneIcon from '../../../../../../resources/js/front/Components/icons/PhoneIcon.vue';
import GridDotsIcon from '../../../../../../resources/js/front/Components/icons/GridDotsIcon.vue';
import LeaseEnquiryForm from './LeaseEnquiryForm.vue';
import RentEnquiryForm from './RentEnquiryForm.vue';
import { Link } from '@inertiajs/vue3';

const props = defineProps({ vehicle: Object, vehicleFinancing: Object })
const galleries = ref(props.vehicle.gallery_images);
galleries.value.unshift(props.vehicle.thumbnail);
const {
    // methods
    show, onHide, changeIndex,
    // refs
    visibleRef, indexRef, imgsRef
} = useEasyLightbox({
    // src / src[]
    imgs: galleries,
    // initial index
    initIndex: 0
})

// let vehicle_financing = {};

let loanFinancing = {
    downpayment: ref(props.vehicleFinancing.downpayment),
    downpayment_amount: ref(props.vehicleFinancing.downpayment_amount),
    interest_rate: ref(props.vehicleFinancing.interest_rate),
    tenure: ref(props.vehicleFinancing.tenure),
    monthly_price_formatted: ref(props.vehicleFinancing.monthly_price_formatted),
    monthly_price: ref(props.vehicleFinancing.monthly_price),
};

var debounce = null;

const recalculateLoan = (input) => {
    clearTimeout(debounce);
    debounce = setTimeout(() => {
        axios.post(route('front.vehicle.loan-financing'), {
            downpayment: loanFinancing.downpayment.value,
            downpayment_amount: loanFinancing.downpayment_amount.value,
            interest_rate: loanFinancing.interest_rate.value,
            tenure: loanFinancing.tenure.value,
            monthly_price_formatted: loanFinancing.monthly_price_formatted.value,
            monthly_price: loanFinancing.monthly_price.value,
            input: input,
            vehicle: props.vehicle.id
        })
            .then((response) => {
                // console.log(response.data);
                loanFinancing.downpayment.value = response.data.downpayment;
                loanFinancing.downpayment_amount.value = response.data.downpayment_amount;
                loanFinancing.interest_rate.value = response.data.interest_rate;
                loanFinancing.tenure.value = response.data.tenure;
                loanFinancing.monthly_price_formatted.value = response.data.monthly_price_formatted;
                loanFinancing.monthly_price.value = response.data.monthly_price;
            })
            .catch((error) => {
                console.error('There was an error!', error);
            });
    }, 600);
};

</script>
